import { useSyncExternalStore } from 'react';

// Whether the "password appeared in a data breach" prompt is showing. A plain module store, not MobX,
// because services/ (where the check runs) never imports the stores.
let shown = false;
const listeners = new Set<() => void>();

const setShown = (next: boolean) => {
  if (shown === next) return;
  shown = next;
  listeners.forEach((listener) => listener());
};

export const showPasswordLeakPrompt = () => setShown(true);
export const hidePasswordLeakPrompt = () => setShown(false);

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => shown;

export function useIsPasswordLeakPromptShown() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
